import React from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  return (
    <div data-testid="cookie-policy-page" className="bg-[#FAFAF7]">
      <section className="mx-auto max-w-[900px] px-5 lg:px-10 pt-16 pb-8">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">— Cookie Policy</div>
        <h1 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] text-[#0A0A0A]">
          Cookie Policy
        </h1>
        <p className="mt-6 text-sm text-[#0A0A0A]/60">
          Informativa sull'utilizzo di cookie e altri strumenti di tracciamento
        </p>
        <p className="mt-2 text-xs uppercase tracking-widest text-[#0A0A0A]/50">
          Ultimo aggiornamento: 31.07.2026
        </p>
      </section>

      <section className="mx-auto max-w-[900px] px-5 lg:px-10 pb-24 legal-doc">
        <p>
          La presente Cookie Policy descrive l'utilizzo di cookie e tecnologie analoghe sul sito gestito da <strong>Perla Music</strong>. Per maggiori informazioni sul trattamento dei dati personali è possibile consultare la <Link to="/privacy" className="text-[#FF5A1F] underline">Privacy Policy</Link> del sito.
        </p>

        <h2>1. Titolare del trattamento</h2>
        <p>
          Il Titolare del trattamento è <strong>Perla Music Ditta Individuale</strong>, in persona del legale rappresentante <strong>Alessio Dell'Armellina</strong>, con sede legale in Via Binda 8/A, Besozzo (VA), P.IVA 04040350128, REA n. 402963, PEC: <a href="mailto:alessiodallarmellina@pec.it">alessiodallarmellina@pec.it</a>.
        </p>

        <h2>2. Cosa sono i cookie e gli strumenti analoghi</h2>
        <p>
          I cookie sono piccoli file di testo che possono essere memorizzati sul dispositivo dell'utente durante la navigazione su un sito web. Il sito può utilizzare anche tecnologie differenti dai cookie, quali il local storage del browser, che consentono di memorizzare informazioni sul dispositivo dell'utente. Ai fini della normativa applicabile, tali tecnologie sono disciplinate in modo analogo ai cookie quando comportano la memorizzazione di informazioni nel dispositivo dell'utente o l'accesso a informazioni già memorizzate.
        </p>

        <h2>3. Categorie di strumenti utilizzati</h2>
        <p>Il sito utilizza:</p>
        <ul>
          <li>strumenti tecnici e funzionali, necessari per il funzionamento del sito e dei servizi richiesti dall'utente;</li>
          <li>strumenti di terze parti collegati alla visualizzazione di video YouTube, attivati esclusivamente previo consenso dell'utente.</li>
        </ul>
        <p>
          Il sito non utilizza attualmente strumenti di web analytics, profilazione pubblicitaria o remarketing quali Google Analytics, Google Tag Manager, Meta Pixel, TikTok Pixel o LinkedIn Insight Tag.
        </p>

        <h2>4. Strumenti tecnici e funzionali</h2>
        <p>
          Gli strumenti tecnici sono utilizzati esclusivamente per consentire il funzionamento del sito, memorizzare le preferenze dell'utente e garantire l'accesso alle aree riservate. Il loro utilizzo non richiede il consenso preventivo dell'utente.
        </p>
        <div className="overflow-x-auto my-6">
          <table className="w-full border-collapse border-2 border-[#0A0A0A] text-sm">
            <thead className="bg-[#F2F2EC]">
              <tr>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Nome</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Tecnologia</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Finalità</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Durata</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Categoria</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>perla_lang</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Local storage</td>
                <td className="border-2 border-[#0A0A0A] p-3">Memorizza la lingua scelta dall'utente, italiano o inglese</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino alla cancellazione da parte dell'utente</td>
                <td className="border-2 border-[#0A0A0A] p-3">Tecnico-funzionale</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>perla_token</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Local storage</td>
                <td className="border-2 border-[#0A0A0A] p-3">Consente l'autenticazione degli utenti autorizzati nell'area amministrativa o CRM</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino al logout e comunque per un massimo di 30 giorni</td>
                <td className="border-2 border-[#0A0A0A] p-3">Tecnico necessario</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Lo strumento <code>perla_token</code> riguarda esclusivamente gli utenti autorizzati ad accedere alle aree /admin o /crm e non viene generato per i normali visitatori del sito. Lo strumento <code>perla_lang</code> viene generato quando l'utente modifica manualmente la lingua del sito.
        </p>

        <h2>5. Google Fonts</h2>
        <p>
          Il sito utilizza il font "Inter", caricato attraverso i servizi Google Fonts. Google Fonts non installa direttamente cookie sul dispositivo dell'utente. Il caricamento del font può tuttavia comportare la trasmissione a Google di informazioni tecniche, quali l'indirizzo IP, il tipo di browser e i dati relativi alla richiesta. Tale trattamento è descritto più dettagliatamente nella Privacy Policy del sito.
        </p>

        <h2>6. Video YouTube</h2>
        <p>Il sito può incorporare video provenienti dalla piattaforma YouTube, gestita da Google. Il caricamento del player YouTube può comportare:</p>
        <ul>
          <li>la trasmissione dell'indirizzo IP e di informazioni tecniche a Google;</li>
          <li>la memorizzazione o la lettura di cookie e identificatori;</li>
          <li>la raccolta di informazioni relative alla visualizzazione e all'interazione con il video;</li>
          <li>l'associazione delle informazioni all'account Google dell'utente, qualora abbia effettuato l'accesso.</li>
        </ul>
        <p>
          Per tale ragione, il player YouTube è bloccato al primo accesso e viene caricato esclusivamente dopo il consenso dell'utente alla categoria "Marketing e contenuti di terze parti". In assenza di consenso, l'utente può continuare a navigare sul sito, ma non potrà visualizzare direttamente il video incorporato.
        </p>
        <div className="overflow-x-auto my-6">
          <table className="w-full border-collapse border-2 border-[#0A0A0A] text-sm">
            <thead className="bg-[#F2F2EC]">
              <tr>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Nome</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Fornitore</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Finalità indicativa</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Durata indicativa</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Categoria</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>VISITOR_INFO1_LIVE</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Funzionamento, personalizzazione e rilevazione di problemi del servizio</td>
                <td className="border-2 border-[#0A0A0A] p-3">Circa 6 mesi</td>
                <td className="border-2 border-[#0A0A0A] p-3">Marketing e contenuti di terze parti</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>YSC</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Memorizza un identificatore relativo alla sessione e alle visualizzazioni</td>
                <td className="border-2 border-[#0A0A0A] p-3">Sessione</td>
                <td className="border-2 border-[#0A0A0A] p-3">Marketing e contenuti di terze parti</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>PREF</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Memorizza preferenze relative alla visualizzazione e riproduzione dei video</td>
                <td className="border-2 border-[#0A0A0A] p-3">Circa 2 anni</td>
                <td className="border-2 border-[#0A0A0A] p-3">Funzionale/marketing di terza parte</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>CONSENT</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Memorizza informazioni relative alle preferenze e al consenso</td>
                <td className="border-2 border-[#0A0A0A] p-3">Circa 2 anni</td>
                <td className="border-2 border-[#0A0A0A] p-3">Funzionale di terza parte</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>__Secure-YEC</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Sicurezza, funzionamento e rilevazione di problemi del servizio</td>
                <td className="border-2 border-[#0A0A0A] p-3">Variabile</td>
                <td className="border-2 border-[#0A0A0A] p-3">Terza parte</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3"><code>SOCS</code></td>
                <td className="border-2 border-[#0A0A0A] p-3">Google/YouTube</td>
                <td className="border-2 border-[#0A0A0A] p-3">Memorizza preferenze relative ai servizi Google</td>
                <td className="border-2 border-[#0A0A0A] p-3">Variabile</td>
                <td className="border-2 border-[#0A0A0A] p-3">Terza parte</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          I nomi, le finalità e le durate degli strumenti di terza parte possono essere modificati direttamente dal relativo fornitore. La presente tabella riporta le informazioni tecniche disponibili al momento dell'ultimo aggiornamento della presente policy.
        </p>

        <h2>7. Collegamenti verso piattaforme esterne</h2>
        <p>
          Il sito può contenere collegamenti verso piattaforme esterne, quali Instagram, Spotify, YouTube, Trustpilot e siti o profili degli artisti. Tali collegamenti non comportano l'installazione di cookie da parte delle piattaforme esterne finché l'utente non seleziona il relativo collegamento. Dopo il clic, l'utente viene indirizzato verso un sito gestito da un soggetto terzo, che tratterà i dati secondo la propria informativa privacy e la propria cookie policy.
        </p>

        <h2>8. Gestione del consenso</h2>
        <p>Al primo accesso al sito, l'utente può:</p>
        <ul>
          <li>accettare tutti gli strumenti;</li>
          <li>rifiutare gli strumenti non necessari;</li>
          <li>personalizzare le proprie preferenze;</li>
          <li>chiudere il banner mantenendo attivi esclusivamente gli strumenti tecnici.</li>
        </ul>
        <p>
          Il mancato consenso non impedisce la navigazione sul sito. Gli strumenti YouTube e gli altri strumenti non tecnici non vengono caricati prima che l'utente abbia espresso una scelta positiva. Il consenso può essere revocato o modificato in qualsiasi momento mediante il collegamento "Gestisci preferenze cookie", disponibile nel footer del sito. La revoca non pregiudica la liceità del trattamento effettuato prima della revoca.
        </p>

        <h2>9. Base giuridica</h2>
        <p>
          L'utilizzo degli strumenti tecnici e funzionali si fonda sulla necessità di fornire il servizio richiesto dall'utente e di garantire il corretto funzionamento del sito, ai sensi dell'art. 122 del D.Lgs. 196/2003. L'attivazione dei video YouTube e degli eventuali strumenti non tecnici si fonda sul consenso dell'utente, ai sensi dell'art. 6, par. 1, lett. a), del Regolamento (UE) 2016/679 e dell'art. 122 del D.Lgs. 196/2003.
        </p>

        <h2>10. Trasferimento dei dati verso Paesi terzi</h2>
        <p>
          L'attivazione dei contenuti YouTube può comportare il trattamento dei dati da parte di Google e delle società appartenenti al relativo gruppo, anche mediante infrastrutture situate fuori dallo Spazio economico europeo. Gli eventuali trasferimenti sono effettuati dal fornitore secondo le garanzie previste dalla normativa applicabile e descritte nelle relative informative.
        </p>

        <h2>11. Gestione degli strumenti tramite il browser</h2>
        <p>L'utente può configurare il browser per:</p>
        <ul>
          <li>verificare quali cookie e dati sono memorizzati;</li>
          <li>eliminare cookie e dati presenti nel local storage;</li>
          <li>bloccare tutti o alcuni cookie;</li>
          <li>impedire l'utilizzo di cookie di terze parti;</li>
          <li>ricevere un avviso prima della memorizzazione di un cookie.</li>
        </ul>
        <p>
          La disabilitazione degli strumenti tecnici può compromettere il corretto funzionamento di alcune funzionalità, quali la memorizzazione della lingua o l'accesso all'area riservata.
        </p>

        <h2>12. Diritti dell'interessato</h2>
        <p>
          L'interessato può esercitare i diritti previsti dagli artt. 15-22 del Regolamento (UE) 2016/679, tra cui accesso, rettifica, cancellazione, limitazione del trattamento, opposizione, portabilità, quando applicabile, e revoca del consenso. Le richieste possono essere inviate agli indirizzi indicati in epigrafe. L'interessato può inoltre proporre reclamo al Garante per la protezione dei dati personali oppure rivolgersi all'autorità giudiziaria competente.
        </p>

        <h2>13. Modifiche alla Cookie Policy</h2>
        <p>
          La presente Cookie Policy può essere aggiornata in conseguenza di modifiche normative, tecniche o organizzative, nonché dell'introduzione di nuovi servizi o strumenti di tracciamento. In particolare, la policy dovrà essere aggiornata prima dell'eventuale attivazione di Meta Pixel, Google Analytics o altri strumenti di marketing e analisi. La versione aggiornata sarà pubblicata sul sito con l'indicazione della data di ultimo aggiornamento.
        </p>
      </section>
    </div>
  );
}
